"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _formik = require("formik");
var _meterReadingFormHelper = require("./meterReadingFormHelper");
var _meterReadingfomValidationHandler = _interopRequireDefault(require("../../utils/meterReadingfomValidationHandler"));
var _meterReadingDateInputHelper = require("../../Core/MeterReadDateInput/meterReadingDateInputHelper");
var _MeterReadingDropdown = _interopRequireDefault(require("../../Core/MeterReadingDropdown/MeterReadingDropdown"));
var _MeterRegisterInput = _interopRequireDefault(require("../../Core/MeterRegisterInput/MeterRegisterInput"));
var _MeterRegisterLabel = _interopRequireDefault(require("../../Core/MeterRegisterLabel/MeterRegisterLabel"));
var _MeterReadDateInput = _interopRequireDefault(require("../../Core/MeterReadDateInput/MeterReadDateInput"));
var _loggedInMeterReadingFormHelper = require("../../LoggedIn/LoggedInMeterReadingForm/loggedInMeterReadingFormHelper");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MeterReadingForm = function MeterReadingForm(props) {
  var deviceData = props.deviceData,
    mandatoryReadingHeadlineMatrix = props.mandatoryReadingHeadlineMatrix;
  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: (0, _meterReadingDateInputHelper.initialValues)(deviceData),
    enableReinitialize: true,
    onSubmit: function onSubmit(values, formikHelpers) {
      (0, _meterReadingFormHelper.saveAndForward)(values, formikHelpers, props.paginate, props.currentPageId, props.lastMeter, props.setCurrentStep, props.nextStep);
    },
    validate: function validate(values) {
      return (0, _meterReadingfomValidationHandler.default)(values, _objectSpread({}, props));
    },
    validateOnMount: true
  }, function (formikProps) {
    var _props$deviceData;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Loader, {
      loading: props.loading || formikProps.isSubmitting,
      fallbackGifSrc: sessionStorage.fallbackLoader
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ano-meter-form",
      id: "meter-form-".concat((_props$deviceData = props.deviceData) === null || _props$deviceData === void 0 ? void 0 : _props$deviceData.serialNumber)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12 col-sm-8 col-md-6 col-sm-offset-2 col-md-offset-3"
    }, mandatoryReadingHeadlineMatrix && deviceData && deviceData.headlineForFirstReadingOrder && deviceData.readingStatus === 'WITH_OPEN_READING_ORDERS' && /*#__PURE__*/_react.default.createElement("h4", {
      className: "text-center ano-meter-counter__text"
    }, (0, _loggedInMeterReadingFormHelper.mapHeadlineText)(deviceData.headlineForFirstReadingOrder, mandatoryReadingHeadlineMatrix))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12 col-sm-8 col-md-6 col-sm-offset-2 col-md-offset-3"
    }, /*#__PURE__*/_react.default.createElement(_MeterReadDateInput.default, (0, _extends2.default)({}, props, {
      headerType: "h5",
      formikProps: formikProps,
      name: "readingDate",
      loggedIn: false
    })))), formikProps.values.registers.map(function (register, index) {
      var classNames = (0, _meterReadingFormHelper.registerHasPlausibilityError)(register) ? 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-0 ano-meter-form__reason-dropdown' : 'col-xs-12 col-sm-8 col-md-6 col-sm-offset-2 col-md-offset-3 ano-meter-form__reason-dropdown';
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(props.deviceData.serialNumber + index, " - label")
      }, /*#__PURE__*/_react.default.createElement(_MeterRegisterLabel.default, (0, _extends2.default)({}, props, {
        headerType: "h5",
        register: register,
        iteration: index,
        classNames: classNames
      })), /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(props.deviceData.serialNumber + index, " - input"),
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classNames
      }, /*#__PURE__*/_react.default.createElement(_MeterRegisterInput.default, (0, _extends2.default)({}, props, {
        formikProps: formikProps,
        formikIdentifier: "registers[".concat(index, "]"),
        register: register,
        index: index,
        unit: formikProps.values.unit
      }))), (0, _meterReadingFormHelper.registerHasPlausibilityError)(register) && /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(classNames, " dropdown-area")
      }, /*#__PURE__*/_react.default.createElement(_MeterReadingDropdown.default, (0, _extends2.default)({}, props, {
        formikProps: formikProps,
        formikIdentifier: "registers[".concat(index, "]"),
        name: "".concat(register.obis, "dropdown"),
        register: register
      })))));
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "ano-meter-form__submit-button text-center"
    }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
      type: "submit",
      qaId: "save-meter-reading-button",
      disabled: !formikProps.isValid || formikProps.isSubmitting || !(0, _meterReadingFormHelper.allRegistersHasPlausibilityReason)(formikProps),
      version: props.versions.button
    }, props.buttonLabel)))))));
  });
};
var _default = exports.default = MeterReadingForm;